import { Hero } from '../components/sections/Hero';
import { Experience } from '../components/sections/Experience';
import { Skills } from '../components/sections/Skills';
import { Projects } from '../components/sections/Projects';
import { Contact } from '../components/sections/Contact';

export function Home() {
  return (
    <main className="pt-16">
      <Hero />
      <Experience />
      <Skills />
      <Projects />
      <Contact />
    </main>
  );
}
